module.exports = __webpack_public_path__ + "img/empty-cart.3a6ee612.png";